import Configs from "../config";
import {
  IStripeIntegration,
  IThrivecartIntegration,
  ReadonlyPartialIThrivecartIntegration,
} from "../generated/Api";
import { localStorageGetItem } from "../utils/LocalStorage";
import { api } from "./GeneratedApi";

async function getAll(): Promise<IThrivecartIntegration[] | null> {
  try {
    const token = localStorageGetItem("USER_TOKEN");
    const response = await fetch(`${Configs.SERVER_URL}/integration/all`, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
      },
    });

    if (response.status === 200) {
      const responseJSON = await response.json();
      return responseJSON.data;
    }

    return null;
  } catch (err) {
    return null;
  }
}

async function disconnect(integrationId: string): Promise<boolean> {
  try {
    const token = localStorageGetItem("USER_TOKEN");
    const response = await fetch(
      `${Configs.SERVER_URL}/integration/${integrationId}`,
      {
        method: "DELETE",
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    );

    if (response.status === 200) {
      return true;
    }

    return false;
  } catch (err) {
    return false;
  }
}

async function create({
  integration,
}: {
  integration: IThrivecartIntegration | IStripeIntegration;
}): Promise<boolean | null> {
  try {
    const token = localStorageGetItem("USER_TOKEN");
    const response = await fetch(`${Configs.SERVER_URL}/integration`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        integration,
      }),
    });

    if (response.status === 200) {
      return true;
    }

    return null;
  } catch (err) {
    return null;
  }
}

async function update({
  userUid,
  integrationId,
  integration,
}: {
  userUid: string;
  integrationId: string;
  integration: ReadonlyPartialIThrivecartIntegration & Record<string, object>;
}): Promise<boolean | null> {
  try {
    let response = await api.integration.integrationPartialUpdate({
      userUid,
      integrationId,
      integration,
    });

    if (response.status === 200) {
      return true;
    }

    return null;
  } catch (err) {
    return null;
  }
}

export const IntegrationAPI = {
  getAll,
  create,
  update,
  disconnect,
};
